import styled from 'styled-components'
import { View } from 'react-native'

export const Vertical8 = styled(View)`
  height: 8px;
`

export const Vertical16 = styled(View)`
  height: 16px;
`
